/** Garde la première occurrence de chaque conversation_sid (ordre préservé). */
export function dedupeConversationsBySid<T extends { conversation_sid?: string }>(
  conversations: T[]
): T[] {
  const seen = new Set<string>();
  const result: T[] = [];
  for (const conv of conversations) {
    const sid = conv.conversation_sid;
    if (!sid || seen.has(sid)) continue;
    seen.add(sid);
    result.push(conv);
  }
  return result;
}
